import { render, staticRenderFns } from "./footerDetalle.vue?vue&type=template&id=2e591cef"
import script from "./footerDetalle.vue?vue&type=script&lang=js"
export * from "./footerDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports